define("shared/components/shared/ui/cluster-switcher", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cNA--group__toggle is--open {{@additionalClass}}" ...attributes>
    <div class="cNA--group__toggleWrapper e--group__toggle at--enagementAccessGroups__toggle">
      <Shared::Ui::GroupAvatar @group={{this.currentGroup}} @showDropDownIcon="true" />
    </div>
  </div>
  
  <Shared::Ui::EmberDrop
    @constrainToScrollParent={{true}}
    @constrainToWindow={{true}}
    @contentSelector=".e--group__drop"
    @position="top left"
    @target=".e--group__toggle"
    as |emberDrop|
  >
    <div class="o--dropWrapper e--group__drop cNA--group__drop">
      <div class="o--dropBody cNA--group__dropBody">
        <ul class="o--dropBody__list">
          {{#if this.isAccountOwner}}
            <li class="o--dropBody__item">
              <LinkTo @route="account.groups" class="o--dropBody__link u--ellipsis">
                <div class="cNA--group__avatar cNA--group__avatar--add">
                  {{svg-jar "add" class="o--icon--md o--icon--light"}}
                </div>
                <div class="cNA--group__info">
                  <span class="o--user__title u--text--light u--ellipsis">
                    {{t "header.navigation.groups.create"}}
                  </span>
                  <span class="o--user__desc u--text--light u--ellipsis">
                    {{t "header.navigation.groups.manage"}}
                  </span>
                </div>
              </LinkTo>
            </li>
          {{/if}}
          {{#each this.groups as |group|}}
            <Shared::Ui::GroupItem
              @closeMenu={{emberDrop.closeAction}}
              @group={{group}}
              @isSelected={{are-equal this.currentGroup.id group.id}}
            />
          {{/each}}
        </ul>
      </div>
      <div class="o--dropFooter">
        {{#if this.isAccountOwner}}
          <Shared::Link
            @href="https://help.later.com/hc/en-us/articles/360042609854-A-Guide-to-Access-Groups"
            @text={{t "header.navigation.groups.help"}}
            class="u--text--light"
          />
        {{/if}}
      </div>
    </div>
  
  </Shared::Ui::EmberDrop>
  */
  {
    "id": "R8zuXR6Z",
    "block": "[[[11,0],[16,0,[29,[\"cNA--group__toggle is--open \",[30,1]]]],[17,2],[12],[1,\"\\n  \"],[10,0],[14,0,\"cNA--group__toggleWrapper e--group__toggle at--enagementAccessGroups__toggle\"],[12],[1,\"\\n    \"],[8,[39,0],null,[[\"@group\",\"@showDropDownIcon\"],[[30,0,[\"currentGroup\"]],\"true\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,1],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@position\",\"@target\"],[true,true,\".e--group__drop\",\"top left\",\".e--group__toggle\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[14,0,\"o--dropWrapper e--group__drop cNA--group__drop\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--dropBody cNA--group__dropBody\"],[12],[1,\"\\n      \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n\"],[41,[30,0,[\"isAccountOwner\"]],[[[1,\"          \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n            \"],[8,[39,3],[[24,0,\"o--dropBody__link u--ellipsis\"]],[[\"@route\"],[\"account.groups\"]],[[\"default\"],[[[[1,\"\\n              \"],[10,0],[14,0,\"cNA--group__avatar cNA--group__avatar--add\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"add\"],[[\"class\"],[\"o--icon--md o--icon--light\"]]]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"cNA--group__info\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"o--user__title u--text--light u--ellipsis\"],[12],[1,\"\\n                  \"],[1,[28,[35,5],[\"header.navigation.groups.create\"],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,1],[14,0,\"o--user__desc u--text--light u--ellipsis\"],[12],[1,\"\\n                  \"],[1,[28,[35,5],[\"header.navigation.groups.manage\"],null]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"groups\"]]],null]],null],null,[[[1,\"          \"],[8,[39,8],null,[[\"@closeMenu\",\"@group\",\"@isSelected\"],[[30,3,[\"closeAction\"]],[30,4],[28,[37,9],[[30,0,[\"currentGroup\",\"id\"]],[30,4,[\"id\"]]],null]]],null],[1,\"\\n\"]],[4]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"o--dropFooter\"],[12],[1,\"\\n\"],[41,[30,0,[\"isAccountOwner\"]],[[[1,\"        \"],[8,[39,10],[[24,0,\"u--text--light\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/articles/360042609854-A-Guide-to-Access-Groups\",[28,[37,5],[\"header.navigation.groups.help\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"]],[3]]]]]],[\"@additionalClass\",\"&attrs\",\"emberDrop\",\"group\"],false,[\"shared/ui/group-avatar\",\"shared/ui/ember-drop\",\"if\",\"link-to\",\"svg-jar\",\"t\",\"each\",\"-track-array\",\"shared/ui/group-item\",\"are-equal\",\"shared/link\"]]",
    "moduleName": "shared/components/shared/ui/cluster-switcher.hbs",
    "isStrictMode": false
  });

  let ClusterSwitcherComponent = (_class = class ClusterSwitcherComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    get groups() {
      return this.auth.groups;
    }

    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = ClusterSwitcherComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ClusterSwitcherComponent);
});